import { connect } from 'react-redux';
import EditAuction from 'components/auctions/EditAuction';
import {
  clearCurrentAuction,
  clearEditedAuction,
  editAuction,
  fetchAuction,
} from 'data/auctions/Auctions.actions';
import { clearGarage, fetchGarage } from 'data/garages/Garages.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = state =>
  ReduxHelper.mapStateWithLookups(
    {
      auction: state.auctions.currentAuction,
      auctionEdited: state.auctions.auctionEdited,
      editError: state.auctions.editError,
      fetchingAuction: state.auctions.fetchingCurrentAuction,
      fetchingGarage: state.garages.fetchingGarage,
      garage: state.garages.currentGarage,
      lang: state.i18n.locale,
      party: state.app.userParty,
      submitting: state.auctions.editingAuction,
      user: state.app.user,
    },
    state,
    'applications',
    'auctionStatuses',
    'bidFileTypes',
    'countries',
    'experts',
    'fuelTypes',
    'imitationPartCategories',
    'insurances',
    'memberships',
    'partTypes',
    'partyTypes',
    'regions',
    'usedConditionTypes'
  );

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchAuction: () => dispatch(fetchAuction(ownProps.params.id)),
  fetchGarage: garageId => dispatch(fetchGarage(garageId)),
  onClearEditAuction: () => {
    dispatch(clearEditedAuction());
    dispatch(clearGarage());
  },
  onSubmit: (auctionData, folderData) =>
    dispatch(editAuction(auctionData, folderData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAuction);
